import { trackDownload } from '../../analytics/posthog'
import { useT } from '../../i18n/useT'

interface DownloadButtonProps {
  text: string
  format: string
  langSuffix?: string
  /** Overrides the default "transcription.<ext>" — the converter hands back
   * the file the user brought in, under its own name */
  filename?: string
}

const extensionMap: Record<string, string> = {
  text: 'txt',
  srt: 'srt',
  vtt: 'vtt',
  ass: 'ass',
  ssa: 'ssa',
  microdvd: 'sub',
  mpl2: 'mpl',
  tmp: 'tmp',
}

export function DownloadButton({ text, format, langSuffix, filename }: DownloadButtonProps) {
  const t = useT()
  function handleDownload() {
    const ext = extensionMap[format] || 'txt'
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename ?? (langSuffix ? `transcription.${langSuffix}.${ext}` : `transcription.${ext}`)
    a.click()
    URL.revokeObjectURL(url)
    trackDownload(format, langSuffix)
  }

  return (
    <button
      onClick={handleDownload}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-text-secondary hover:text-text rounded-lg hover:bg-surface-hover transition-colors"
      title={t('result.downloadTitle')}
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
      </svg>
      {t('result.download')}
    </button>
  )
}
